import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/BgImg03.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2> Alpha Team Of Developers With A Global Footprint</h2>
            </div>
            <p>
              At TekRevol, we are pushing boundaries to help our clients and
              tech partners achieve the technical success they envision for
              their businesses. We are an A-team of developers, UI UX creatives,
              app consultants, game strategists, and project managers currently
              on a mission to impact the global business infrastructure with
              emerging tech.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
